import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import { Provider } from "react-redux";
import store from "./redux/store";
import Home from './components/Home';

const theme = createMuiTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: '#080303',
      
    },
    secondary: {
      // This is green.A700 as hex.
      main: '#8E7037',
      light:'rgba(142, 112, 55, 0.67)'
    },
  },
  typography: {
   
    fontFamily: [
      "Poppins", 'sans-serif'
    ].join(',')
  }
});
/*
,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
*/
ReactDOM.render(
  <Provider store={store}>
  <ThemeProvider theme={theme}>
    <Router basename="/">
        <App />
    </Router>
  </ThemeProvider>
  </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
